import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=cd8c9abe&scoped=true&"
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.vue?vue&type=style&index=0&id=cd8c9abe&scoped=true&lang=css&"
import style1 from "./wallet.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8c9abe",
  null
  
)

export default component.exports